import { useState, MouseEvent } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import { Menu, Button, DropdownLink } from './Dropdown.style';

export type DropdownItem = {
  name: string;
  to: string;
};

type HeaderDropdownProps = {
  isScrolled: boolean;
  label: string;
  items: DropdownItem[];
  color: string;
};

export const Dropdown = ({ label, items, isScrolled, color }: HeaderDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box mr={4}>
      <Button
        sx={{ color }}
        isScrolled={isScrolled}
        aria-haspopup="menu"
        aria-expanded={open ? 'true' : 'false'}
        aria-controls="dropdown-menu"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {label}
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        <ClickAwayListener onClickAway={handleClose}>
          <Box px={2} py={1.75}>
            {items.map(({ name, to }, index) => {
              return (
                <Box key={index} mt={index !== 0 ? 1.5 : 0}>
                  <DropdownLink to={to} onClick={handleClose}>
                    {name}
                  </DropdownLink>
                </Box>
              );
            })}
          </Box>
        </ClickAwayListener>
      </Menu>
    </Box>
  );
};
